var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gray-bg",staticStyle:{"min-height":"100vh"}},[_c('div',{staticClass:"middle-box text-center animated fadeInDown"},[_c('h3',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.error || 'Redirecting...')+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72866771","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/User/PageRedirect.vue
// module id = null
// module chunks = 